import React, { PropsWithChildren } from 'react';

const AuthContainer: React.FC<PropsWithChildren> = ({ children }) => (
  <div className="container relative flex h-screen flex-col items-center justify-center md:grid lg:max-w-none lg:grid-cols-2 lg:px-0">
    <div className="relative hidden h-full flex-col p-8 text-white lg:flex dark:border-r">
      <div
        className="absolute inset-0 bg-zinc-900"
        style={{
          backgroundImage:
            "linear-gradient(180deg,rgba(0, 0, 0, 0.7) 0%, rgba(255, 255, 255, 0) 50%), url('/images/auth-background.jpg')",
          backgroundSize: 'cover',
          backgroundPositionX: 'calc(100% + 5rem)',
        }}
      />
      <div className="relative z-20 flex items-center text-lg font-medium">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="hidden mr-2 h-6 w-6"
        >
          <path d="M15 6v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3" />
        </svg>
        <img src="/favicon.svg" alt="Fleet Flow" className="mr-2 h-6 w-auto" />
        Fleet Flow
      </div>
      <div className="relative z-20 mt-auto">
        <blockquote className="hidden space-y-2">
          <p className="text-lg">
            &ldquo;This library has saved me countless hours of work and helped
            me deliver stunning designs to my clients faster than ever
            before.&rdquo;
          </p>
          <footer className="text-sm">Sofia Davis</footer>
        </blockquote>
      </div>
    </div>
    {children}
  </div>
);

export default AuthContainer;
